import { scale as initialScale, scaleOP } from '@components/frame';
import { font as initialFont, fontOP } from '@styles/fonts';
import { useNavigationCheck } from '@v2/pages/machines/hooks/useNavigationCheck';

export const useAlertScaleFont = () => {
  const { safeIsOperatorPanelInfoScreen } = useNavigationCheck();
  const scale = safeIsOperatorPanelInfoScreen ? scaleOP : initialScale;
  const font = safeIsOperatorPanelInfoScreen ? fontOP : initialFont;

  return { scale, font };
};
